<template>
  <v-card flat class="pa-4">
    <v-container xclass="py-0" fluid>
      <v-row dense>
        <v-col cols="6" sm="4">
          <v-combobox label="Home currency" v-model="settings.homeCurrency" persistent-hint :disabled="settings.multiCurrency"
                    :items="['CAD','USD']" outlined dense
                    :hint="settings.multiCurrency?'This cannot be changed if multicurrency enabled':''"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="10">
          <v-tooltip bottom max-width="300" nudge-top="20" open-delay="1000">
            <template v-slot:activator="{on}">
              <v-switch v-model="multiCurrency" @change="showConfirm=true"
                          :disabled="multiCurrency || company.connectedToAccounting" persistent-hint
                          :hint="company.connectedToAccounting ? 'Must be enabled througth QBO' : 'Cannot be disabled once set'">
                <span slot="label" v-on="on">Multicurrency support</span>
              </v-switch>
            </template>
            If multicurrency support is enabled, it cannot be disabled and the home currency cannot be changed.
            Multicurrency cannot be enabled if connected to QuickBooks Online.
            If that is the case, enable multicurrency support in QuickBooks Online and then synchronize.
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="showConfirm" persistent max-width="400">
      <v-card>
        <v-card-title>Enable multi-currency?</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Once enabled, you cannot disable multi-currency. Are you sure?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="error" plain @click="settings.multiCurrency=true; showConfirm=false">Enable</v-btn>
          <v-btn color="primary" @click="multiCurrency=false; showConfirm=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import settingsPreferences from '@/views/settings/preferences/settingsPreferences'

export default {
  name: 'SettingsPreferencesGeneralCurrency',
  mixins: [settingsPreferences],
  data() {
    return {
      multiCurrency: false,
      showConfirm: false
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  created() {
    this.multiCurrency = this.settings.multiCurrency;
  },
}
</script>